import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-recommend-form__list-3" }
const _hoisted_2 = { class: "p-login-form__checkbox" }
const _hoisted_3 = ["id", "name", "value", "checked", "onChange"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_5 = ["for"]
const _hoisted_6 = { style: {"align-items":"flex-start"} }
const _hoisted_7 = { class: "p-login-form__checkbox" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "p-recommend-form__label",
  for: `form-purpose-other`
}, "その他", -1)

import { onMounted, ref, watch } from 'vue';
import ValidatableField from '@/components/ValidatableField.vue';
import store from '@/store';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
type CheckboxItem = {
  id: string | number;
  text: string;
  selected: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendPurposeAgent',
  props: {
    modelValue: null,
    textareaValue: null,
    otherChecked: { type: Boolean },
    setFieldValue: null
  },
  emits: ["update:modelValue", "update:textareaValue", "update:otherChecked"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: number[]): void;
  (e: 'update:textareaValue', value: string): void;
  (e: 'update:otherChecked', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue?: number[]; // チェックされたチェックボックスのリスト
  textareaValue?: string; // テキストエリアの内容
  otherChecked?: boolean; // その他チェックボックスの状態  
  setFieldValue: <T extends string>(field: T, value: any, opts?: any) => void;
}

const storeBase = MYPAGE_CONSTANTS.STORE_MST;





const purposeData = ref<CheckboxItem[]>([]);
const otherSelected = ref(false);
const otherText = ref('');

// テキストエリアの値が変更された時の監視
watch(() => props.textareaValue, (newValue) => {
  if (newValue !== undefined) {
    otherText.value = newValue;
    props.setFieldValue('purposeAgentMemo', newValue);
    // テキストエリアに値がある場合、otherチェックボックスを自動的にチェック
    if (newValue && newValue.trim() !== '') {
      otherSelected.value = true;
    }
  }
}, { immediate: true });

watch(() => otherText.value, (newValue) => {
  if (newValue !== undefined) {
    emit('update:textareaValue', otherSelected.value ? newValue : '');
  }
}, { immediate: true });

// otherCheckedの値が変更された時の監視
watch(() => props.otherChecked, (newValue) => {
  if (newValue !== undefined) {
    otherSelected.value = newValue;
  }
}, { immediate: true });

// 選択されたチェックボックスの値が変更された時の監視
watch(() => props.modelValue, (newValue) => {
  if (newValue !== undefined) {
    
    purposeData.value.forEach(item => {
      item.selected = newValue.includes(Number(item.id));
    });

    // otherチェックボックスの状態はテキストエリアの内容に基づいて決定
    // ここでは何もしない（textareaValueの監視で処理）
  }
}, {immediate: true});

// チェックボックスの変更を処理
const handleCheckboxChange = (item: CheckboxItem) => {
  item.selected = !item.selected;
  updateValues();
};

// 値を更新して親コンポーネントに送信
const updateValues = () => {
  // 選択されたチェックボックスのIDを取得
  let selectedIds = purposeData.value
    .filter(item => item.selected)
    .map(item => Number(item.id));
  // otherはselectedIdsに含めない
  // otherの状態はテキストエリアの内容で判断

  if (!otherSelected.value) {
    // otherがチェックされていない場合、テキストエリアの値をクリア
    otherText.value = '';
    emit('update:textareaValue', '');
  }

  // 親コンポーネントに値を送信
  emit('update:modelValue', selectedIds);
  
  // otherチェックボックスの状態を送信
  emit('update:otherChecked', otherSelected.value);

  // テキストエリアの値を送信（otherがチェックされていない場合は空文字）
  emit('update:textareaValue', otherSelected.value ? otherText.value : '');
};

// 目的データの読み込み
async function loadPurposeData() {
  const data = await store.dispatch(storeBase.MST_PURPOSEAGENT);
  purposeData.value = data.map((p) => ({
    id: p.id,
    text: p.text,
    selected: false,
  }));

  // 初期値がある場合、選択状態を更新
  if (props.modelValue) {
    const selectedIds = props.modelValue;

    purposeData.value.forEach(item => {
      item.selected = selectedIds.includes(Number(item.id));
    });
  }

  // テキストエリアに値がある場合、otherチェックボックスを自動的にチェック
  if (props.textareaValue && props.textareaValue.trim() !== '') {
    otherText.value = props.textareaValue;
    otherSelected.value = true;
  } else {
    otherSelected.value = props.otherChecked || false;
  }
  // 初期値を更新
  updateValues();
}

onMounted(async () => {
  await loadPurposeData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(purposeData.value, (chk, idx) => {
      return (_openBlock(), _createElementBlock("li", {
        key: chk.id
      }, [
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("input", {
            id: `form-purpose-0${idx + 1}`,
            type: "checkbox",
            name: `form-purpose-0${idx + 1}`,
            value: chk.id,
            checked: chk.selected,
            onChange: ($event: any) => (handleCheckboxChange(chk))
          }, null, 40, _hoisted_3),
          _hoisted_4
        ]),
        _createElementVNode("label", {
          class: "p-recommend-form__label",
          for: `form-purpose-0${idx + 1}`
        }, _toDisplayString(chk.text), 9, _hoisted_5)
      ]))
    }), 128)),
    _createElementVNode("li", _hoisted_6, [
      _createElementVNode("span", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          id: "form-purpose-other",
          type: "checkbox",
          name: "form-purpose-other",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((otherSelected).value = $event)),
          onChange: updateValues
        }, null, 544), [
          [_vModelCheckbox, otherSelected.value]
        ]),
        _hoisted_8
      ]),
      _hoisted_9
    ]),
    _createElementVNode("ul", {
      class: _normalizeClass(["p-recommend-form__list-1 js-entry-list", { '-is-disabled': !otherSelected.value }]),
      "data-entries": "1",
      id: "form-purpose-other-list"
    }, [
      _createVNode(ValidatableField, {
        as: "textarea",
        class: "p-recommend-form__textarea",
        name: "purposeAgentMemo",
        label: "その他",
        id: "form-purpose-other-name",
        placeholder: "その他を入力してください",
        "model-value": otherText.value,
        "onUpdate:model-value": _cache[1] || (_cache[1] = ($event: any) => ((otherText).value = $event)),
        rules: {
          recommendRequired: otherSelected.value,
          max:70
        },
        disabled: !otherSelected.value,
        maxlength: "70"
      }, null, 8, ["model-value", "rules", "disabled"])
    ], 2)
  ]))
}
}

})